export default "/images/799310c6ac3a54a8e82d925534fd2bc0.avif";